export const LINE_SERIES_COLOR = ['#3366FF', '#FF9500', '#CC41D9', '#14CCBD', '#199FFF', '#858585'];
export const BAR_SERIES_COLOR = [
  '#52BBFF',
  '#3366FF',
  '#FF9500',
  '#CC41D9',
  '#14CCBD',
  '#83D537',
  '#858585'
];
const LineSeriesColorLen = LINE_SERIES_COLOR.length;
const BarSeriesColorLen = BAR_SERIES_COLOR.length;
export function getLineColor(seriesLen: number, seriesIndex: number) {
  const idx = seriesIndex % LineSeriesColorLen;
  if (seriesIndex === seriesLen - 1 && seriesLen > 1) {
    return LINE_SERIES_COLOR[LineSeriesColorLen - 1];
  }
  return LINE_SERIES_COLOR[idx];
}

export function getBarColor(seriesIndex: number, isSingleBar = false) {
  if (isSingleBar) {
    return BAR_SERIES_COLOR[1];
  }
  const idx = seriesIndex % BarSeriesColorLen;
  return BAR_SERIES_COLOR[idx];
}
